import React, { useEffect, useState } from "react";
import { StorageItems } from "../../../utils/storageItems";
import { darkModeBackgroudInputs } from "../../../utils/constants";
import { useDarkModeStore } from "../../../store/useDarkModeStore";
import { Modal, ModalContent, StyledBackdrop, } from "../../../common/TopBar/Buttons/SearchTopBarModal";
import Button from "@mui/joy/Button";
import Sheet from "@mui/joy/Sheet";
import CssBaseline from "@mui/joy/CssBaseline";
import useScreenWidth from "../../../store/useScreenWidth";

interface OnBoardModalProps {
    modal: boolean;
    selected: string[];
    setModal: React.Dispatch<React.SetStateAction<boolean>>;
    setSelected: React.Dispatch<React.SetStateAction<string[]>>;
}

const data = [
    { id: 1, name: "Ticket", value: 'ticket' },
    { id: 2, name: "Fixed Asset", value: 'asset' },
    { id: 3, name: "Procurement", value: 'procurement' },
    { id: 4, name: "Reports", value: 'report' },
]

const OnBoardModal = ({ modal, selected, setModal, setSelected }: OnBoardModalProps) => {
    const isSmallScreen = useScreenWidth();
    const { darkMode } = useDarkModeStore();

    const [items, setItems] = useState<string[]>(selected || []);
    useEffect(() => {
        if (selected) setItems(selected);
        else setItems([]);
    }, [selected]);

    const onSubmit = () => {
        setSelected(items);
        localStorage.setItem(StorageItems.SELECTEDCOMPONENTS, items.join(","));
        setModal(false);
    }

    return <Modal
        open={modal}
        onClose={() => setModal(false)}
        slots={{ backdrop: StyledBackdrop }}
    >
        <ModalContent sx={{ width: "fit-content", border: 'none !important' }}>
            <CssBaseline />
            <Sheet
                sx={{
                    width: isSmallScreen ? 250 : 510,
                    my: 0,
                    py: 2,
                    px: 6,
                    display: "flex",
                    flexDirection: "column",
                    gap: 0,
                    borderRadius: "14px",
                    border: 'none !important',
                    background: darkMode ? darkModeBackgroudInputs : "white",
                }}
            >
                <div className="d-flex flex-row pb-0 mb-4 align-items-center justify-content-center position-relative">
                    <span
                        className='input-group-text border-0 fw-bold'
                        id="addon-wrapping"
                        style={{
                            color: darkMode ? "white" : "var(--text-theme-color)",
                            cursor: "default",
                            fontSize: isSmallScreen ? 14 : 20,
                            background: darkMode ? darkModeBackgroudInputs : "white",
                        }}
                    >
                        Select Modules to Configure
                    </span>
                </div>
                <div
                    className="grid-container"
                    style={{ gridTemplateColumns: isSmallScreen ? '1fr' : 'repeat(2, 1fr)' }}
                >
                    {
                        data.map((item) => (
                            <div
                                key={item.id}
                                className="grid-container-item"
                                role="button"
                                onClick={() => {
                                    setItems(prev =>
                                        prev.includes(item.value)
                                            ? prev.filter(i => i !== item.value) // remove dynamically
                                            : [...prev, item.value] // add dynamically
                                    );
                                }}
                                style={{
                                    border: items.includes(item.value) ? "1.5px solid var(--text-theme-color)" : "none",
                                }}
                            >
                                {item.name}
                            </div>
                        ))
                    }

                </div>

                <div
                    className="d-flex align-items-center"
                    style={{ fontSize: "16px" }}
                >

                    <Button
                        className="w-100"
                        sx={{
                            background: "var(--btn-color)",
                            color: "white",
                            "&:hover": {
                                background: "var(--btn-color)",
                                opacity: .7
                            },
                        }}
                        onClick={onSubmit}
                    >
                        Configure
                    </Button>
                </div>
            </Sheet>
        </ModalContent>
    </Modal>
}

export default OnBoardModal;